<template>
    <div>
        <form-wrapper @submit="submitLocationForm(data)">
            <locations-fragment
                :states="states"
                :formData="data"
                :isUpdatingLocation="true"
                :hasAutofocus="true"
                valuePath="locations"
                @change="change($event)"
            ></locations-fragment>
            <template #footer>
                <common-buttons>
                    <common-button
                        :isSubmittable="false"
                        :label="$t('pages.practice.profile.buttons.secondary')"
                        type="secondary"
                        @click="goToIndex"
                    ></common-button>
                    <common-button
                        :isProcessing="isSending"
                        :label="$t('pages.practice.profile.buttons.primary')"
                        type="primary"
                    ></common-button>
                </common-buttons>
            </template>
        </form-wrapper>
        <set-availability-modal
            v-if="isSetAvailabilityModalOpen"
            :firstNewLocationId="firstNewLocationId"
        ></set-availability-modal>
        <common-are-you-sure-modal
            v-if="isAreYouSureModalOpen"
            :headingText="$t('pages.referrals.show.disclaimer_modal.heading')"
            :contentText="$t('pages.practice.billing.add_location_warning')"
            :noButtonText="$t('common.microcopy.close')"
            :yesButtonText="$t('common.microcopy.continue')"
            :showWarningIcon="true"
            @close="isAreYouSureModalOpen = false"
            @continue="saveLocations"
        ></common-are-you-sure-modal>
    </div>
</template>

<script>
    import FormMixin from 'mixins/FormMixin'
    import FormFragmentMixin from 'mixins/FormFragmentMixin'
    import FormDisableableMixin from 'mixins/FormDisableableMixin'
    import StatesAPI from 'api/StatesAPI'
    import PracticesAPI from 'api/PracticesAPI'
    import SetAvailabilityModal from 'components/page-elements/practice/SetAvailabilityModal'
    import Store from '~/store'

    export default {
        mixins: [FormMixin, FormFragmentMixin, FormDisableableMixin],

        components: {
            SetAvailabilityModal,
        },

        props: {},

        data() {
            return {
                states: [],
                data: {},
                isSending: false,
                isSetAvailabilityModalOpen: false,
                firstNewLocationId: null,
                isAreYouSureModalOpen: false,
                locationData: {},
            }
        },

        methods: {
            loadData() {
                StatesAPI.getList().then((res) => (this.states = res))
                const practice = this.$auth.getPractice()
                const mainLocation = {
                    address: practice.address,
                    city: practice.city,
                    state: practice.state,
                    zip: practice.zip,
                }
                this.data = {
                    id: practice.id,
                    name: practice.name,
                    email: practice.email,
                    password: practice.password,
                    phone: practice.phone,
                    locations: [mainLocation, ...practice.locations],
                }
            },

            submitLocationForm(data) {
                if (this.$auth.isPracticeAncillary()) {
                    this.openAreYouSureModal(data)
                } else {
                    this.locationData = data
                    this.saveLocations()
                }
            },

            openAreYouSureModal(data) {
                this.locationData = data
                this.isAreYouSureModalOpen = true
            },

            saveLocations() {
                this.isAreYouSureModalOpen = false
                this.handleFormSubmission(this.locationData)
            },

            handleFormSubmission(data) {
                this.isSending = true
                this.emitEvent({ name: 'is-sending', payload: this.isSending })
                return this.handleRequest(PracticesAPI.update(this.data.id, data))
                    .then((response) => {
                        //removing main location
                        const locations = data?.locations?.slice(1)
                        if (locations?.some((item) => !item.id)) {
                            Store.dispatch('auth/setPractice', response)
                            const indexOfLastAddedLocation = locations.findIndex((item) => !item.id)
                            this.firstNewLocationId = response.locations[indexOfLastAddedLocation].id
                            if (!this.$auth.isUserPracticeOther()) {
                                this.isSetAvailabilityModalOpen = true
                            } else {
                                this.goToIndex()
                            }
                        } else {
                            this.goToIndex()
                        }
                    })
                    .finally(() => {
                        this.emitEvent({ name: 'is-sending', payload: this.isSending })
                        this.isSending = false
                    })
            },

            goToIndex() {
                this.$auth.isPracticeAncillary()
                    ? this.$router.push({ name: 'practice.profile-ancillary' })
                    : this.$router.push({ name: 'practice.profile' })
            },
        },

        mounted() {
            this.loadData()
        },
    }
</script>
